// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.antiersolutions",
    name: "Ancrypto Wallet",
    homepage: "https://www.antiersolutions.com/",
    image_id: "d4382329-e288-4d7a-0ac8-3eb0facfb900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/in/app/ancrypto-wallet/id1453657650",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "ancrypto://app",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map